import { Location } from '../location/types';

export interface TeamMemberWorkingHoursDay {
  open?: boolean;
  from_time?: string;
  to_time?: string;
  breaks?: { from: string; to: string }[];
}

export interface TeamMemberHoliday {
  id?: number;
  date: string;
  reason: string;
}

export interface TeamMember {
  id: number;
  first_name: string;
  last_name?: string;
  job_title?: string;
  email: string;
  sip_uri?: string;
  extension?: string | number;
  phone_number: string;
  mapped_agent_id?: number | null;
  working_hours?: Record<string, TeamMemberWorkingHoursDay>;
  holidays?: TeamMemberHoliday[];
  sms_consent?: boolean;
  role?: 'business_admin' | 'location_admin' | 'operator';
  agency_owner?: boolean;
  locations?: Location[];
  location_ids?: number[] | null;
  /** Legacy team API field; prefer first_name when present */
  name?: string;
}

export interface TeamMemberRequest {
  team_member: {
    first_name: string;
    last_name?: string;
    job_title?: string;
    email?: string;
    phone_number?: string;
    sip_uri?: string;
    extension?: string | number;
    sms_consent?: boolean;
    working_hours?: Record<string, TeamMemberWorkingHoursDay>;
    holidays?: TeamMemberHoliday[];
    role: 'business_admin' | 'location_admin' | 'operator';
    location_ids?: number[] | null;
  };
}

export enum TeamMemberRole {
  Admin = 'business_admin',
  Manager = 'location_admin',
  Operator = 'operator'
}

export enum AgencyTeamMemberRole {
  Owner = 'owner',
  Manager = 'manager'
}

export function getTeamMemberDisplayName(
  member?: {
    first_name?: string;
    last_name?: string;
    name?: string;
  } | null
): string {
  if (!member) return '';
  const fromParts = [member.first_name, member.last_name].filter(Boolean).join(' ').trim();
  return fromParts || member.name || '';
}
